import * as React from "react"
import { CaseModel } from "./models"
import ResourceCard from "../atoms/ResourceCard"
import { Link } from "react-router-dom"
import Button from "../atoms/buttons/Button"
import { ArrowRight } from "../atoms/icons/ArrowRight"
import ImageHeader from "../atoms/ImageHeader"
import { Inset, HorizontalSpacer } from "../atoms/spacers"
import BodyMedium from "../atoms/typography/BodyMedium"
import H1 from "../atoms/typography/H1"
import styled from "styled-components"
import { useContentfulInspectorMode } from "@contentful/live-preview/react"
import ButtonTextSmall from "../atoms/typography/ButtonTextSmall"
import { LinkInNewTabIcon } from "../atoms/icons/LinkInNewTabIcon"

const Content = styled(Inset)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const LinkTextButton = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 8px;
  align-self: stretch;
  flex-wrap: no-wrap;
`

const CaseCard: React.FC<CaseModel<string>> = (props) => {
  const inspectorProps = useContentfulInspectorMode({ entryId: props.sys?.id })

  return (
    <ResourceCard {...inspectorProps({ fieldId: "title" })}>
      <ImageHeader src={props.hero?.image?.url} width={100} />
      <Content spacing={2}>
        <div>
          <a href={props.externalLink} target="_blank" rel="noopener noreferrer">
            <LinkTextButton>
              <div style={{ flexShrink: 0 }}>
                <LinkInNewTabIcon />
              </div>
              <ButtonTextSmall>{props.externalLinkText}</ButtonTextSmall>
            </LinkTextButton>
          </a>
          <HorizontalSpacer spacing={1} />
          <H1 bold>{props.title}</H1>
          <HorizontalSpacer spacing={1} />
          <BodyMedium>{props?.description}</BodyMedium>
          <HorizontalSpacer spacing={2} />
        </div>
        <Link to={`/applications/${props.slug}`}>
          <Button
            title="Read more"
            iconRight={<ArrowRight />}
            variant={props?.color ?? "dark"}
            size="normal"
            fullWidth={true}
          />
        </Link>
      </Content>
    </ResourceCard>
  )
}

export default CaseCard
